<template>
<div class="dropdown-item">
  <a v-if="showTrigger"
    class="dropdown-trigger"
    :class="[triggerClasses]" ref="trigger" :data-target="'dropdown'+dropdownID">
    <slot name="text"></slot>
  </a>
  <div :id="'dropdown'+dropdownID" v-if="dataType === 'slots'" 
    class="dropdown-content">
    <slot name="items"> </slot>
  </div>
  <ul :id="'dropdown'+dropdownID" v-if="dataType === 'lists'" 
    class="dropdown-content">
    <li v-for="(item, index) in listItems" v-bind:key="index">
      <router-link :to="item.link"></router-link>
    </li>
  </ul>
</div>
</template>

<script>
import M from 'materialize-css'
export default {
  name: 'DropDown',
  props: {
    dataType:{
      type: String,
      default: 'slots'
    },
    showTrigger: {
      type:Boolean,
      default:true
    },
    onOpenEnd: {
      type: Function,
    },
    triggerClasses: {
      type: String,
      default: 'slots'
    },
    dataAlign: {
      type: String,
      default: 'right'
    },
    buttonText:{
      type: String,
      default: 'Page Link'
    },
    closeOnClick: {
      type: Boolean,
      default: false,
    },
    coverTrigger: {
      type: Boolean,
      default: true,
    },
    minWidth:{
      type: [Number, Boolean],
      default: 200
    }
  },
  data () {
    let vm = this
    return {
      dropdownID:Math.random().toString(36).substr(2, 9),
      instance:null,
      options:{
        closeOnClick: vm.closeOnClick,
        constrainWidth:false,
        onOpenEnd: () => {
          vm.onOpenEnd ? vm.onOpenEnd : ''
        },
        coverTrigger:vm.coverTrigger,
        autoTrigger:true,
        hover:false,
        alignment: vm.dataAlign
      }
    }
  },
  created () {
  },
  mounted () {
    this.$_initDropdown()
  },
  beforeDestroy () {
    if (this.instance !== null) {
      this.instance.destroy()
    }
  },
  methods: {
    $_initDropdown(){
      this.instance = M.Dropdown.init(this.$refs.trigger, this.options)
    }
  }
}
</script>
<style lang="scss" scoped>
.drop-down-content {
/*   top:-200px; */
    .dropdown-content {
    left: initial !important;
  /*  z-index: 9999;
      transform-origin: 0 0;*/ 
      top: initial !important;  
      right: 16px !important;
      width: 250px !important;
      border-radius: 5px;
  }
}
.footer-nav-dropdown {
  .dropdown-content {
    top: inherit !important;
    width: 350px !important;
    left: 50vw !important;
    margin-left: -175px;
    transform-origin: 45vw 100% !important;
    @media screen and (min-width: 768px) {
      transform-origin: 25vw 100% !important;
    }
    @media screen and (min-width: 1024px) {
      transform-origin: 10vw 100% !important;
    }
    border-radius: 8px;
    bottom: 18px !important;
  }
}
</style>